
const ExtensionPrivacyPolicy = () => {
    const styles = {
        container: {
            fontFamily: "Arial, sans-serif",
            lineHeight: "1.6",
            padding: "24px",
            maxWidth: "900px",
            margin: "auto",
            color: "#222",
        },
    };

    return (
        <div style={styles.container}>
            <h1>Privacy Policy</h1>
            <p>Last updated: December 2025</p>

            <p>
                This Privacy Policy explains how the Multi-Chain Crypto Wallet browser
                extension ("the Extension", "we", "our", or "us") handles user data. We
                are committed to protecting your privacy and ensuring transparency about
                how information is used.
            </p>

            <h2>1. Information We Collect</h2>
            <p>
                The Extension does <strong>not</strong> collect, store, or transmit any
                personally identifiable information.
            </p>

            <p>All sensitive wallet data, including but not limited to:</p>
            <ul>
                <li>Private keys</li>
                <li>Public wallet addresses</li>
                <li>Account metadata</li>
                <li>User preferences</li>
            </ul>

            <p>
                is stored <strong>locally on the user's device</strong> and is
                encrypted. This data never leaves the user's browser.
            </p>

            <h2>2. How Information Is Used</h2>
            <p>
                The locally stored data is used solely to provide core wallet
                functionality, including:
            </p>
            <ul>
                <li>Managing crypto accounts</li>
                <li>Sending and receiving blockchain transactions</li>
                <li>Displaying balances and transaction history</li>
                <li>Remembering user-selected settings</li>
            </ul>

            <h2>3. Network and Blockchain Access</h2>
            <p>
                To function correctly, the Extension connects to public blockchain
                networks and RPC endpoints to retrieve real-time blockchain data such as
                balances, transaction status, and network information.
            </p>
            <p>
                These requests may include public wallet addresses but never include
                private keys or sensitive personal data.
            </p>

            <h2>4. Data Sharing</h2>
            <p>
                We do not sell, trade, rent, or share user data with third parties. The
                Extension does not use advertising services, analytics trackers, or
                third-party data collection tools.
            </p>

            <h2>5. Permissions</h2>
            <p>
                The Extension only requests permissions that are necessary for its
                single purpose as a crypto wallet. Permissions such as storage and
                active tab access are used strictly for user-initiated wallet
                functionality.
            </p>

            <h2>6. Security</h2>
            <p>
                We take security seriously and implement industry-standard practices to
                protect locally stored data. However, users are responsible for
                safeguarding their recovery phrases and devices.
            </p>

            <h2>7. Children's Privacy</h2>
            <p>
                The Extension is not intended for use by children under the age of 13.
                We do not knowingly collect any personal information from children.
            </p>

            <h2>8. Changes to This Policy</h2>
            <p>
                This Privacy Policy may be updated from time to time. Any changes will
                be reflected on this page with an updated revision date.
            </p>

            <h2>9. Contact</h2>
            <p>
                If you have questions or concerns about this Privacy Policy, please
                contact the extension developer through the Chrome Web Store listing.
            </p>
        </div>
    );
};

export default ExtensionPrivacyPolicy;
